

export default function TimezoneOffset() {
  const offsetMinutes = new Date().getTimezoneOffset();
  const utcOffset = Math.floor(offsetMinutes / -60);
  return utcOffset;
}